type SelfSupplyEligibleMarket = {
  state: string;
  utility: string;
};

const isSelfSupplyEligibleMarket = (
  value: unknown
): value is SelfSupplyEligibleMarket =>
  typeof value === "object" &&
  value !== null &&
  "state" in value &&
  "utility" in value &&
  typeof (value as SelfSupplyEligibleMarket).state === "string" &&
  typeof (value as SelfSupplyEligibleMarket).utility === "string";

const getSelfSupplyEligibleMarkets = (
  value: unknown
): SelfSupplyEligibleMarket[] => {
  const parseArray = (items: unknown[]): SelfSupplyEligibleMarket[] =>
    items.filter(isSelfSupplyEligibleMarket);

  if (!value) return [];

  if (Array.isArray(value)) {
    return parseArray(value);
  }

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parseArray(parsed);
      }
    } catch {
      return [];
    }
  }

  return [];
};

const isSelfSupplyEligible = (
  state: string,
  utility: string,
  eligibleMarkets: SelfSupplyEligibleMarket[]
): boolean =>
  eligibleMarkets.some(
    (market) =>
      market.state === state &&
      utility.toLowerCase().includes(market.utility.toLowerCase())
  );

export type { SelfSupplyEligibleMarket };
export { getSelfSupplyEligibleMarkets, isSelfSupplyEligible };
